<template>
  <div class="role-filter-panel">
    <div class="select-all-group">
      <a-checkbox
        v-model:checked="brandAllChecked"
        @change="
          (e) => {
            const value = e.target.checked
            onCheckAllChange(value, 'brand')
          }
        "
        class="header-cb"
      >
        {{
          $t('admin.' + name.charAt(0).toUpperCase() + name.slice(1) + ' Brand')
        }}
      </a-checkbox>
      <a-checkbox
        v-model:checked="roleAllChecked"
        @change="
          (e) => {
            const value = e.target.checked
            onCheckAllChange(value, 'role')
          }
        "
        class="header-cb"
      >
        {{ $t('admin.Role') }}
      </a-checkbox>
      <!-- <a-checkbox
        v-model:checked="levelAllChecked"
        :indeterminate="levelIndeterminate"
        @change="
          (e) => {
            const value = e.target.checked
            onCheckAllChange(value, 'level')
          }
        "
        class="header-cb"
      >
        Level
      </a-checkbox> -->
    </div>
    <div class="select-group">
      <div class="select-group-item select-brand">
        <a-checkbox-group
          v-model:value="brandChecked"
          name="brandG"
          class="cb-group"
        >
          <div
            v-for="(item, index) in options.brand"
            :key="index"
            class="option-cb"
          >
            <a-checkbox :value="item">
              {{ item }}
            </a-checkbox>
          </div>
        </a-checkbox-group>
      </div>
      <div class="dividing-line"></div>
      <div class="select-group-item select-role">
        <a-checkbox-group
          v-model:value="roleChecked"
          name="roleG"
          class="cb-group"
        >
          <div
            v-for="(item, index) in options.role"
            :key="index"
            class="option-cb"
          >
            <a-checkbox :value="item">
              {{ item }}
            </a-checkbox>
          </div>
        </a-checkbox-group>
      </div>
      <!-- <div class="dividing-line" />
      <div class="select-group-item select-level">
        <a-checkbox-group
          v-model:value="levelChecked"
          name="levelG"
          class="cb-group"
        >
          <div
            v-for="(item, index) in options.level"
            :key="index"
            class="option-cb"
          >
            <a-checkbox :value="item">
              {{ item }}
            </a-checkbox>
          </div>
        </a-checkbox-group>
      </div> -->
    </div>
    <div class="action-group">
      <a-button type="link" @click="clearAll">
        {{ $t('admin.Clear All') }}
      </a-button>
      <a-button @click="cancelFilter">{{ $t('admin.Cancel') }}</a-button>
      <a-button type="primary" @click="applyFilter">
        {{ $t('admin.Apply') }}
      </a-button>
    </div>
  </div>
</template>
<script>
  import { getRoleOptionsData } from '@/api/admin'
  import { toRaw } from '@vue/reactivity'
  import bus from '@/lib/bus'
  export default {
    name: 'RoleFilter',
    components: {},
    props: {
      cycleID: { type: Number },
      setSelectedKeys: {
        default: () => {},
      },
      selectedKeys: {
        default: {},
      },
      confirm: {
        default: () => {},
      },
      clearFilters: {
        default: () => {},
      },
      column: {
        default: {},
      },
      name: {
        default: '',
      },
    },
    data() {
      return {
        options: {
          brand: [],
          role: [],
          level: [],
        },
        brandIndeterminate: false,
        roleIndeterminate: false,
        levelIndeterminate: false,
        brandAllChecked: false,
        roleAllChecked: false,
        levelAllChecked: false,
        brandChecked: [],
        roleChecked: [],
        levelChecked: [],
      }
    },
    created() {
      this.getData()
      // this.levelChecked = this.selectedKeys.level || []
      const _agency = this.selectedKeys.filter((el) => el.key === 'agency')
      const _role = this.selectedKeys.filter((el) => el.key === 'role')
      if (_agency.length > 0 && _agency[0].value) {
        this.brandChecked = _agency[0].value || []
      }
      if (_role.length > 0 && _role[0].value) {
        this.roleChecked = _role[0].value || []
      }
      // this.brandChecked = this.selectedKeys.brand || []
      // this.roleChecked = this.selectedKeys.role || []
      // this.levelChecked = this.selectedKeys.level || []
    },
    computed: {},
    watch: {
      cycleID() {
        this.getData()
      },
      brandChecked(val) {
        this.watchCheckBox('brand', val)
      },
      roleChecked(val) {
        this.watchCheckBox('role', val)
      },
      levelChecked(val) {
        this.watchCheckBox('level', val)
      },
    },
    methods: {
      getData() {
        getRoleOptionsData(this.cycleID).then((res) => {
          if (res.code == 200) {
            this.options = res.data
          }

          if (this.name === 'current') {
            if (this.$route.query.filteredInfo) {
              this.filteredInfo = JSON.parse(this.$route.query.filteredInfo)
              this.brandChecked = this.filteredInfo.current.agency || []
              this.roleChecked = this.filteredInfo.current.role || []
              this.levelChecked = this.filteredInfo.current.level || []
            }
          }

          if (this.name === 'target') {
            if (this.$route.query.filteredInfo) {
              this.filteredInfo = JSON.parse(this.$route.query.filteredInfo)
              this.brandChecked = this.filteredInfo.target.agency || []
              this.roleChecked = this.filteredInfo.target.role || []
              this.levelChecked = this.filteredInfo.target.level || []
            }
          }
        })
      },
      watchCheckBox(type, val) {
        if (val.length == 0) {
          this[`${type}Indeterminate`] = false
          this[`${type}AllChecked`] = false
        } else if (val.length == this.options[type].length) {
          this[`${type}Indeterminate`] = false
          this[`${type}AllChecked`] = true
        } else {
          this[`${type}Indeterminate`] = true
          this[`${type}AllChecked`] = false
        }
      },
      clearAll() {
        this.brandIndeterminate = false
        this.roleIndeterminate = false
        this.levelIndeterminate = false
        this.brandAllChecked = false
        this.roleAllChecked = false
        this.levelAllChecked = false
        this.brandChecked = []
        this.roleChecked = []
        this.levelChecked = []

        this.clearFilters()
      },
      cancelFilter() {
        this.confirm()
      },
      applyFilter() {
        // if (this.levelChecked.length == 0) {
        //   return
        // }
        function formateAllcheckedData(options, value) {
          if (options.length === value.length) {
            return []
          } else {
            return toRaw(value)
          }
        }
        const data = ['brand', 'role', 'level'].map((key) => {
          return {
            key,
            value: formateAllcheckedData(
              this.options[key],
              this[`${key}Checked`]
            ),
          }
        })
        this.setSelectedKeys(data)
        bus.emit('loadEmployeeData', { columnKey: this.name, data })
        this.confirm()
      },
      onCheckAllChange(value, key) {
        this[`${key}Indeterminate`] = false
        if (value == true) {
          this[`${key}Checked`] = this.options[key]
        } else {
          this[`${key}Checked`] = []
        }
      },
    },
  }
</script>
<style lang="less">
  @import url('@/styles/params.less');
  .role-filter-panel {
    // width: 650px;
    background: white;
  }
  .header-cb {
    font-size: 14px;
    // font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #000000;
    line-height: 22px;
    padding: 16px 12px;
  }
  .option-cb {
    font-size: 14px;
    font-family: Helvetica;
    color: #333333;
    line-height: 22px;
    padding: 5px 12px;
  }
  .select-all-group,
  .select-group {
    display: flex;
    justify-content: center;
    .header-cb,
    .select-group-item {
      width: 247px;
      max-height: 300px;
      overflow: auto;
    }
    .cb-group {
    }
    .dividing-line {
      width: 1px;
      flex-grow: 0;
      height: 100%;
      background-color: red;
    }
  }
  .action-group {
    height: 64px;
    border-top: 1px solid #0000000f;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 16px;
    .ant-btn {
      margin: 0 8px;
    }
  }
</style>
